<div *ngIf="filteredChannelList?.length > 0">
    <table mat-table [dataSource]="dataSource" class="table">
        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef class="table-header">
                {{ getCounter() }}
            </th>
            <td
                mat-cell
                *matCellDef="let channel"
                class="checkbox-row"
                [ngClass]="{
                    'disable-click': selectedChannels.length >= availableChannelCount && !channel.checked,
                }">
                <mat-checkbox
                    [(ngModel)]="channel.checked"
                    (click)="checkChannel(channel, true); $event.stopPropagation()"
                    [disabled]="selectedChannels.length >= availableChannelCount && !channel.checked">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="Ch. Name">
            <th
                data-cy="select-channel-window-channel-list-ch-name-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header">
                {{ 'channel-search.dialog.table.channel.name' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let channel"
                class="table-row channel-row"
                [ngClass]="{
                    selected: channel.checked,
                    'disable-click': selectedChannels.length >= availableChannelCount && !channel.checked,
                }">
                <div class="row-container" style="gap: 8px">
                    <div>{{ channel.opsData.tag }}</div>
                    <div class="name">{{ channel.opsData.name }}</div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Ch. Type">
            <th
                data-cy="select-channel-window-channel-list-ch-group-label"
                mat-header-cell
                *matHeaderCellDef
                class="table-header type">
                {{ 'channel-search.dialog.table.channel.type' | translate }}
            </th>
            <td
                mat-cell
                *matCellDef="let channel"
                class="table-row channel-row"
                [ngClass]="{
                    selected: channel.checked,
                    'disable-click': selectedChannels.length >= availableChannelCount && !channel.checked,
                }">
                <div class="row-container" style="gap: 8px">
                    <div class="type">{{ channel.opsData.channelType }}</div>
                    <div class="row-container" style="gap: 4px" *ngIf="!channelIsDigital(channel.fcuData.channelType)">
                        <div class="row-container">
                            {{ getScaledMeasureRange(channel.fcuData)}}
                        </div>
                        <div>
                            {{ channel.opsData.measurementUnit }}
                        </div>
                    </div>
                    <div class="row-container" style="gap: 4px" *ngIf="channelIsDigital(channel.fcuData.channelType)">
                        <div class="row-container">
                            {{ channel.fcuData.digitalAlarmSetting.statusStringContactOn }}
                            {{ '/' }}
                            {{ channel.fcuData.digitalAlarmSetting.statusStringContactOff }}
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header"></tr>
        <tr
            data-cy="select-channel-window-channel-list-option"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="checkChannel(row, false)"
            [ngClass]="{ selected: row.checked }"></tr>
    </table>
</div>
